import { render, staticRenderFns } from "./PodtEditPlmtrlChild.vue?vue&type=template&id=35fa3b4b&"
import script from "./PodtEditPlmtrlChild.vue?vue&type=script&lang=js&"
export * from "./PodtEditPlmtrlChild.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditPlmtrlChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports